import "./ProjectHeroPokeMania.scss";

function ProjectHeroPokeMania() {
  return (
    <>
      <section class="project-cs-hero">
        <div class="project-cs-hero__content">
          <h1 class="heading-primary">PokeMania</h1>
          <div class="project-cs-hero__info">
            <p class="text-primary text-primary--project">
              A trivia game application for guessing the names of Pokémon
              characters.
            </p>
          </div>
          <div class="project-cs-hero__cta">
            <a
              href="https://supreet-kaur-pokemania.netlify.app/"
              class="btn btn--bg"
              target="_blank"
              rel="noreferrer"
            >
              Live Link
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectHeroPokeMania;
